import { render, staticRenderFns } from "./StdPagination.vue?vue&type=template&id=ba06ab3a&scoped=true"
import script from "./StdPagination.vue?vue&type=script&lang=js"
export * from "./StdPagination.vue?vue&type=script&lang=js"
import style0 from "./StdPagination.vue?vue&type=style&index=0&id=ba06ab3a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba06ab3a",
  null
  
)

export default component.exports